import React, { useEffect, useState } from "react";
import Ellipse1580 from "../../assets/images/Ellipse 1580.png";
import Ellipse1588 from "../../assets/images/Ellipse 1588.png";
import Ellipse1587 from "../../assets/images/Ellipse 1587.png";
import Ellipse1589 from "../../assets/images/Ellipse 1589.png";
import msg_line from "../../assets/images/msg_line.png";
import home_icn from "../../assets/images/home_icn.png";
import down_icn from "../../assets/images/down_icn.png";
import messages_icn from "../../assets/images/messages_icn.png";
import attendance from "../../assets/images/att-mark.png";
import homework from "../../assets/images/hme-wrk-blue.png";
import schoolbus from "../../assets/images/skool-bus-blue.png";
import fee from "../../assets/images/fee-img-blue.png";
import results from "../../assets/images/results-blue.png";
import assignments from "../../assets/images/assign-blue.png";
import library from "../../assets/images/library-blue.png";
import timetable from "../../assets/images/time-table-blue.png";
import gallery from "../../assets/images/gallery-blue.png";
import postmarks from "../../assets/images/post-marks-blue.png";
import contact from "../../assets/images/contact-blue.png";
import feedback from "../../assets/images/feedback-blue.png";
import onlineexam from "../../assets/images/online-exam-blue.png";
import sendmessage from "../../assets/images/send-msg.png";

import greenline from "../../assets/images/green-line.png";
import orangeline from "../../assets/images/orange-line.png";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router";
import "./home-page.css";
import { getLocalStorage } from "../../core/localStorageService";
import {studentTabs } from "./studentTabs"
import { PayloadProps } from "../../core/schema";
import apiEndpoint from "../../core/apiend_point";
import { triggerApi } from "../../services";

/**
 * Renders Component.
 * @return {HomePage} renders Component.
 */
export default function HomePage() {
  const navigate = useNavigate();
  useEffect(() => {
    const userData = getLocalStorage("user") ? JSON.parse(getLocalStorage("user") ?? "") : "";
    if(userData.student && userData.student.length > 0){
      setStudent(userData.student[0]);
    }
  }, []);

  const [percentage, setPercentage] = useState(0);
  const [feePercentage, setFeePercentage] = useState<number>(0);
  const [totalFeePaid, setTotalFeePaid] = useState(0);
  const [totalFees, setTotalFees] = useState(0);
  const [student, setStudent] = useState<any>({});
  const [studentAttendance, setStudentAttendance] = useState<any>({
    presentDays: 0,
    totalDays: 0,
    attendancePercentage: 0
  });
  
  
  useEffect(() => {
    getStudentTotalFee();
    getStudentTotalAttendance();
  }, []);

  const getStudentTotalAttendance = () => {
    const user: any = getLocalStorage("user") ? JSON.parse(getLocalStorage("user") ?? "") : "";
    const apiObject: PayloadProps = {
      payload: {
        user_id: user?.student[0]?.user_id,
        academic_years_id: user?.student[0]?.academic_years_id,
      },
      method: "POST",
      apiUrl: apiEndpoint.getStudentAttendance,
    };

    triggerApi(apiObject)
      .then((res: any) => {
        console.log(res.data)
        if (res.data.statusCode && res.data.statusCode === "success") {
          setStudentAttendance({
            presentDays: parseInt(res.data.total_present_days),
            totalDays: parseInt(res.data.total_days),
            attendancePercentage: parseInt(res.data.attendance_percentage)
          })
        } else {
          console.log(res);
        }
        //   setIsLoginButton(false);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const getStudentTotalFee = () => {
    const user: any = getLocalStorage("user") ? JSON.parse(getLocalStorage("user") ?? "") : "";
    const apiObject: PayloadProps = {
      payload: {
        auth_token: getLocalStorage("token"),
        user_id: user?.student[0]?.user_id,
        academic_years_id: user?.student[0]?.academic_years_id, //getLocalStorage('users_type_id'),
        page_count: 1,
      },
      method: "POST",
      apiUrl: apiEndpoint.getStudentFeesTotals,
    };

    triggerApi(apiObject)
      .then((res: any) => {
        if (res.statusCode && res.statusCode === "success" && res.data.length > 0) {
          console.log(res.data[0])
          setTotalFeePaid(res.data[0].total_received_amount);
          setTotalFees(res.data[0].total_mapped_amount);
          let feePercentage:any = (parseFloat(res.data[0].total_received_amount)/parseFloat(res.data[0].total_mapped_amount)) * 100;
          setFeePercentage(feePercentage.toFixed(2))
        } else {
          console.log(res);
        }
        //   setIsLoginButton(false);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const onTabClick = (route:string) =>{
    navigate(route)
  }

  return (
    <>
      <div className="p-0 gradient_clr cmmn">
        <Row className="bg-white p-3 justify-content-between mx-auto">
          <Col
            xs={5}
            className="d-flex justify-content-center align-items-center blue_clr"
          >
              <img
                src={home_icn}
                alt="..."
                className=""
                width="15px"
                height="15px"
              />
              <span role="button" className="fw-bolder f-14 px-2 link_style">
                Home
              </span>
          </Col>
          <Col
            xs={5}
            className="inactive_clr d-flex justify-content-center align-items-center"
            onClick={() => navigate("/messages")}
          >
            <img
              src={messages_icn}
              alt="..."
              className=""
              width="15px"
              height="15px"
            />
            <span role="button" className="f-14 px-2 text-decoration-none status_clr fw-bold link_style">
              {" "}
              Messages
            </span>
          </Col>
        </Row>
        <Container className=" position-relative z-ind_2">
          <Row className="mt-1">
            <Col xs={9}>
              <div className="bg-white brdr_16 py-2 px-2 mx-auto">
                <div className="d-flex justify-content-between align-items-center p-1">
                  <div className="d-flex">
                    <img
                      src={student?.photo_url}
                      alt="..."
                      className="rounded-circle"
                      width="36px"
                      height="36px"
                    />

                    <div className="d-flex flex-column align-items-start px-2">
                      <p className="m-0 f-14 fw-bolder">{student?.name}</p>
                      <p className="m-0 f-12 status_clr">
                        {student?.sem_name} • {student?.sec_name} Sec • {student?.roll_number}
                      </p>
                    </div>
                  </div>
                  {/* <div className="text-end">
                    <img
                      src={down_icn}
                      alt="..."
                      className="mt-1"
                      width="15px"
                      height="15px"
                    />
                  </div> */}
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mt-5 justify-content-around">
            <Col xs={6} lg={2} className="d-flex justify-content-around">
              <div className="att_clr">
                <div style={{ width: 55 }}>
                  <CircularProgressbar
                    value={studentAttendance.attendancePercentage}
                    text={`${studentAttendance.attendancePercentage}%`}
                  />
                </div>
              </div>

              <div className="drk_txt">
                <p className="mb-0 f-12">Attendance</p>
                <img
                  src={greenline}
                  alt="..."
                  className="m-75"
                  width="80px"
                  height="6px"
                />
                <p className="f-10">{studentAttendance.presentDays}/{studentAttendance.totalDays}</p>
              </div>
            </Col>
            <Col xs={6} lg={2} className="d-flex justify-content-around">
              <div className="homewrk_clr">
                <div style={{ width: 55 }}>
                  <CircularProgressbar
                    value={feePercentage}
                    text={`${feePercentage}%`}
                  />
                </div>
              </div>

              <div className="drk_txt">
                <p className="mb-0 f-12">Fee</p>
                <img
                  src={orangeline}
                  alt="..."
                  className="m-75"
                  width="80px"
                  height="6px"
                />
                <p className="f-10">{totalFeePaid}/{totalFees}</p>
              </div>
            </Col>
          </Row>
          
          <Row className="mt-4">
            {studentTabs.map((data:any, i:number) => {
              return (<Col xs={4} className="cursor mt-2"
              key={i}
              onClick={() => onTabClick(data.route)}
              >
              <div className="hme_box brdr_16 d-flex justify-content-center align-content-center flex-wrap">
                <img
                  src={data.icon}
                  alt="..."
                  className="m-75"
                  width="15px"
                  height="15px"
                />
              </div>
              <div className="text-center f-12 mt-1 drk_txt">{data.label}</div>
            </Col>)
            })}
            
            </Row>
        </Container>
        <div className="position-relative z-ind_1" style={{ bottom: "276px" }}>
          <div className="position-absolute elipse1588_pos">
            <img src={Ellipse1588} alt="" width="70px" height="70px" />
          </div>
          <div className="position-absolute elipse1587_pos">
            <img src={Ellipse1587} alt="" width="44px" height="44px" />
          </div>
          <div className="position-absolute elipse1589_pos">
            <img src={Ellipse1589} alt="" width="93px" height="93px" />
          </div>
        </div>
      </div>
    </>
  );
}
